import serviceHandler from "@/helpers/handlers/service";

export const limitsMixin = {
  async created() {
    this.loading = true;
    await this.fetchItems();
    this.loading = false;
  },
  data() {
    return {
      items: [],
      itemsSelected: false,
      loading: false
    };
  },
  computed: {
    selectedItemsIds() {
      return this.items.filter(item => item.selected).map(item => item.id);
    }
  },
  methods: {
    async fetchItems() {
      const items = await serviceHandler(this.itemsFetchHandler());
      this.items = items;
    },
    async deleteSelected() {
      if (!this.selectedItemsIds.length) {
        return;
      }
      this.loading = true;
      await Promise.all(this.prepareRequests());
      await this.fetchItems();
      this.$emit("deleted");
      this.itemsSelected = false;
      this.loading = false;
    },
    prepareRequests() {
      const requests = [];
      this.selectedItemsIds.forEach(id =>
        requests.push(serviceHandler(this.itemDeleteHandler(id)))
      );
      return requests;
    },
    selectItem(item) {
      item.selected = !item.selected;
      this.itemsSelected = this.items.filter(item => item.selected).length > 0;
    }
  }
};
